import React, { useState, useContext } from "react";
import { AuthContext } from "../AuthContext";
import { changePassword } from "../api";

export default function ChanPasswd() {
  const { user } = useContext(AuthContext);
  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmaSenha, setConfirmaSenha] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null); // { type: 'error'|'success', text: '...' }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg(null);

    // Validação local: nova senha e confirmação devem ser iguais
    if (novaSenha !== confirmaSenha) {
      setMsg({ type: "error", text: "A confirmação da nova senha não confere." });
      return;
    }

    setLoading(true);

    try {
      await changePassword(user.token, senhaAtual, novaSenha);
      setMsg({ type: "success", text: "Senha alterada com sucesso!" });
      setSenhaAtual("");
      setNovaSenha("");
      setConfirmaSenha("");
    } catch (error) {
      setMsg({ type: "error", text: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="dashboard-container">
        <div className="user-grid">
          <div className="user-card">
            <h3>Trocar Senha</h3>
            <form onSubmit={handleSubmit} className="card-actions">
              <div className="form-group labels">
                <label>Senha Atual</label>
                <input
                  type="password"
                  value={senhaAtual}
                  onChange={(e) => setSenhaAtual(e.target.value)}
                  placeholder="Digite sua senha atual"
                  required
                />
                <label>Nova Senha</label>
                <input
                  type="password"
                  value={novaSenha}
                  onChange={(e) => setNovaSenha(e.target.value)}
                  placeholder="Digite a nova senha"
                  required
                />
                <label>Confirme a Nova Senha</label>
                <input
                  type="password"
                  value={confirmaSenha}
                  onChange={(e) => setConfirmaSenha(e.target.value)}
                  placeholder="Repita a nova senha"
                  required
                />
              </div>
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? <span className="spinner"></span> : "Alterar Senha"}
              </button>
              {msg && (
                <div className={msg.type === "error" ? "error-msg" : "success-msg"}>
                  {msg.text}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
